import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";

export default function radioZodSchema({ required, options }: FormInputSchemaParams) {
	const allowedValues = (options ?? []).map((option) => option.value).filter((value): value is string => typeof value === "string");
	const allowedSet = new Set(allowedValues);

	return z.any().superRefine((value, ctx) => {
		if (required && !value) {
			ctx.addIssue({ code: "custom", message: "required" });
			return;
		}

		if (value && (typeof value !== "string" || !allowedSet.has(value))) {
			ctx.addIssue({ code: "custom", message: "invalidRadio" });
		}
	});
}
